import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button } from "@chakra-ui/react";

const ConfirmModal = ({ isOpen, onClose, onConfirm, message }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Potvrdite akciju</ModalHeader>
                <ModalBody>{message}</ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose}>Povratak</Button>
                    <Button colorScheme="red" ml={3} onClick={onConfirm}>Potvrdi</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmModal;
